/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},

  REJECTED_DOCUMENTS_SUCCESS: {
    message: 'Application submitted Successfully',
  },
  REJECTED_DOCUMENTS_ERROR: {
    message: 'Failed to submit application',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.rejectedDocuments',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_REJECTED_DOCUMENTS' },
      },
    },
    INITIATE_REJECTED_DOCUMENTS: {
      invoke: {
        id: 'rejectedDocuments',
        src: 'rejectedDocuments',
        onDone: {
          target: 'REJECTED_DOCUMENTS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REJECTED_DOCUMENTS_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    REJECTED_DOCUMENTS_SUCCESS: {
      // type: 'final',
      on: {
        TRIGGER_REFRESH: {
          target: 'idle',
        },
      },
    },
    REJECTED_DOCUMENTS_ERROR: {
      // type: 'final',
      on: {
        MUTATE: { target: 'INITIATE_REJECTED_DOCUMENTS' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
